import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { openWhatsApp } from '../lib/whatsapp';

const { FiArrowUpRight } = FiIcons;

const projects = [
  {
    number: '01',
    name: 'The Willow House',
    type: 'Full-service design',
    location: 'Brooklyn, NY',
    year: '2024',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1500&q=85',
    alt: 'Warm modern living space with sculptural furniture',
    desc: 'A sun-soaked brownstone reimagined with limewashed walls, vintage finds, and a palette drawn from the garden.',
  },
  {
    number: '02',
    name: 'A Quiet Kind of City',
    type: 'Renovation',
    location: 'Manhattan, NY',
    year: '2023',
    image: 'https://images.unsplash.com/photo-1600210491369-e753d80a41f3?auto=format&fit=crop&w=1500&q=85',
    alt: 'Elegant apartment interior with natural light',
    desc: 'A pre-war apartment stripped back to its bones, then layered with plaster, oak, and the kind of calm you can feel.',
  },
  {
    number: '03',
    name: 'Sunday House',
    type: 'Full-service design',
    location: 'Hudson Valley, NY',
    year: '2023',
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1500&q=85',
    alt: 'Calm contemporary dining room with warm wood finishes',
    desc: 'A weekend retreat built around long meals, slow mornings, and a deep connection to the surrounding woods.',
  },
  {
    number: '04',
    name: 'The Linen Loft',
    type: 'Styling & sourcing',
    location: 'Tribeca, NY',
    year: '2022',
    image: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=1500&q=85',
    alt: 'Soft, textural loft interior with linen furnishings',
    desc: 'A wide-open loft softened with linen, rattan, and a careful edit of objects collected over years of travel.',
  },
];

function WorkRow({ project, index }) {
  const reversed = index % 2 === 1;
  return (
    <motion.article
      className={`work-row ${reversed ? 'is-reversed' : ''}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, delay: 0.05 }}
    >
      <button
        className="work-row-image"
        type="button"
        onClick={() => openWhatsApp(`Hello Forma Interiors, I'm interested in the "${project.name}" project.`)}
        aria-label={`Enquire about ${project.name}`}
      >
        <img src={project.image} alt={project.alt} loading="lazy" />
        <span className="work-row-arrow"><SafeIcon icon={FiArrowUpRight} /></span>
        <span className="work-row-number">{project.number}</span>
      </button>
      <div className="work-row-copy">
        <span className="work-row-eyebrow">{project.type} · {project.location}</span>
        <h3>{project.name}</h3>
        <p>{project.desc}</p>
        <div className="work-row-meta">
          <span><strong>Location</strong> {project.location}</span>
          <span><strong>Year</strong> {project.year}</span>
          <span><strong>Scope</strong> {project.type}</span>
        </div>
        <button
          className="work-row-cta"
          type="button"
          onClick={() => openWhatsApp(`Hello Forma Interiors, I'm interested in the "${project.name}" project.`)}
        >
          Enquire about this project <SafeIcon icon={FiArrowUpRight} />
        </button>
      </div>
    </motion.article>
  );
}

function WorkSection() {
  return (
    <section className="work-section" id="work">
      <div className="section-wrap work-head">
        <div>
          <p className="eyebrow">A considered collection</p>
          <h2>
            Spaces with a sense <br /> of <em>belonging.</em>
          </h2>
        </div>
        <p className="section-intro">
          Every project begins with listening. The result is a home that feels collected, personal, and quietly distinct.
        </p>
      </div>
      <div className="work-rows">
        {projects.map((project, index) => (
          <WorkRow key={project.number} project={project} index={index} />
        ))}
      </div>
    </section>
  );
}

export default WorkSection;
